// extracted by mini-css-extract-plugin
export default {"root":"QYJfI9u_","actions":"aWDNkATl","panels":"Nm0_SVRS","panel":"a2LSw3so"};